import { DateTime } from 'luxon';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import {
  LocalStorageKeys,
  CommonFields,
  PORTAL_ROLES,
  RoleFlags,
} from '@/types';

export type JwtContent = JwtPayload & CommonFields;

export const storeToken = (newToken: string | null): void => {
  if (newToken === null) {
    window?.localStorage.removeItem(LocalStorageKeys.ACCESS_TOKEN);
  } else {
    window?.localStorage.setItem(LocalStorageKeys.ACCESS_TOKEN, newToken);
  }
};

export const retrieveToken = (): Promise<string | null> =>
  new Promise((resolve) => {
    if (typeof window === 'undefined') {
      const checkWindow = setInterval(() => {
        if (typeof window !== 'undefined') {
          clearInterval(checkWindow);
          resolve(window.localStorage.getItem(LocalStorageKeys.ACCESS_TOKEN));
        }
      }, 50);
    } else {
      resolve(window?.localStorage.getItem(LocalStorageKeys.ACCESS_TOKEN));
    }
  });

export const tokenIsValid = (token: JwtContent): boolean => {
  if (!token.exp) {
    return false;
  }

  const expiryDate = DateTime.fromSeconds(token.exp);

  if (expiryDate < DateTime.local()) {
    return false;
  }

  return true;
};

export const decodeToken = (token: string): JwtContent | undefined => {
  const decodedToken = jwtDecode<JwtContent>(token);

  if (!tokenIsValid(decodedToken)) {
    storeToken(null);

    return;
  }

  return decodedToken;
};

export const roleFlagsFromToken = (token: JwtContent): RoleFlags => ({
  isQA: token.isQA,
  isPortalUser: PORTAL_ROLES.includes(token.role),
  isAdmin: token.role === 'Admin',
  isSalesUser: token.role === 'SalesUser',
  isSchoolAdmin: token.role === 'SchoolAdmin',
  isStudent: token.role === 'Student',
  isTeacher: token.role === 'Teacher',
  isParent: token.role === 'Parent',
});
